class Callbacks {
  static filterToFormHandler() {
    return function filterToForm(filter) {
      return filter
    }
  }
  static filterToStateHandler(companycontract) {
    return function filterToState(state) {
      return { companycontract }
    }
  }
  static formToFilterHandler() {
    return function formToFilter(values, extra, meta, state) {
      return {
        company_contract: _.get(state, 'companycontract'),
        noshow: { '!': null },
      }
    }
  }
}

export default Callbacks
